import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import BuildingOwnersContent from './BuildingOwnersContent';
import BuildingOwnerModal from '../modals/BuildingOwnerModal';

const form = {
  keyword: '',
};

function BuildingOwnersContainer({
  match,
  history,
  getList,
  dataList,
  isLoading,
  dataListPager,
  showData,
  removeData,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <BuildingOwnerModal dataInfo={data.attributes} id={data.id} type="EDIT" />,
      title: 'Update Building Owner',
      modalSize: 'modal-lg',
      modalContentSize: 'custom-size'
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to remove this building owner?',
      () => {
        removeData(data.id, () => {
          getList();
          const id = _.get(dataList, '0.id');
          history.push(
            `/rpt/building/building-owners/${id}`
          );
          showData(id);
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getList({ name: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:buildingOwnerId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Building Owners"
            getData={getList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:buildingOwnerId?`}
            listName="buildingOwners"
            label="Building Owners"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.first_name')} {"  "} {_.get(item, 'attributes.last_name')}
                </div>
              </div>
            )}
            isLoading={isLoading}
            selected={params.buildingOwnerId}
            data={dataList}
            dataPager={dataListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            noRightCard
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:buildingOwnerId?`}
                    render={() => (
                      <BuildingOwnersContent
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:buildingOwnerId?`}
                  render={() =>
                    !params.buildingOwnerId && dataList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(dataList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

BuildingOwnersContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  dataList: PropTypes.instanceOf(Array).isRequired,
  dataListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  removeData: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  dataList: _.get(api, `${c.GET_LIST}.list`) || [],
  dataListPager: _.get(api, `${c.GET_LIST}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BuildingOwnersContainer);
